import RLottie, { LottieComponentProps } from 'lottie-react'
import React from 'react'
import styled, { css } from 'styled-components'

export const lottieStyles = css`
	.render-target {
		height: 100%;
		width: 100%;
	}
`

const LottieView = styled.div`
	${lottieStyles}
`

export type LottieProps = Omit<LottieComponentProps, 'animationData'> & {
	file: any
}
export const Lottie = ({ file, loop = false, className, ...options }: LottieProps) => {
	const props: LottieComponentProps = {
		animationData: file,
		loop,
		className: `render-target`,
		...options,
	}

	return (
		<LottieView className={`lottie${className ? ` ${className}` : ''}`}>
			<RLottie {...props} />
		</LottieView>
	)
}
